<div>
  <mat-grid-list [cols]="1">
    <div class="center-column">
      <!-- <huge-row class="mat-padding">
        <mat-col>
          <img src="assets/img/hugeconnect.png" alt="logo" class="hugeLogo">
        </mat-col>
      </huge-row> -->
      <br />
      <br />
      <br />
      <br />
      <br />
      <div class="card wrapper center-column">
        <huge-row>
          <mat-col class="text-align-center">
            <p class="identity-card-title"> Change Password </p>
          </mat-col>
        </huge-row>
        <huge-row>
          <mat-col class="text-align-center">
            <p class="identity-card-subtitle vertical-margin"> Please enter your new password: </p>
          </mat-col>
        </huge-row>
        <form [formGroup]="formGroup">
          <mat-list-item class="form-field-width">
            <mat-label position="floating" color="primary">Password</mat-label>
            <input matInput formControlName="passwordControl" [type]="'password'" (keyup.enter)="resetPassword()" required />
          </mat-list-item>
          <div>
            @for (validation of validation_messages.passwordControl; track validation) { @if ( formGroup.get('passwordControl').hasError(validation.type) &&
            (formGroup.get('passwordControl').dirty || formGroup.get('passwordControl').touched) ) {
            <div class="validation-error-message">
              {{ validation.message }}
            </div>
            } }
          </div>

          <mat-list-item class="form-field-width">
            <mat-label position="floating" color="primary">Confirm Password</mat-label>
            <input matInput formControlName="confirmPasswordControl" type="password" [type]="'password'" (keyup.enter)="resetPassword()" required />
          </mat-list-item>
          <div>
            @for (validation of validation_messages.passwordControl; track validation) { @if ( formGroup.get('confirmPasswordControl').hasError(validation.type) &&
            (formGroup.get('confirmPasswordControl').dirty || formGroup.get('confirmPasswordControl').touched) ) {
            <div class="validation-error-message">
              {{ validation.message }}
            </div>
            } }
          </div>
          <div>
            @for (validation of validation_messages.matching_passwords; track validation) { @if ( formGroup.hasError(validation.type) &&
            (formGroup.get('confirmPasswordControl').dirty || formGroup.get('confirmPasswordControl').touched) ) {
            <div class="validation-error-message">
              {{ validation.message }}
            </div>
            } }
          </div>
        </form>
        <huge-row class="mat-margin-top mat-justify-content-center">
          <mat-col>
            <button class="btn primary-btn" expand="full" (click)="resetPassword()">Save</button>
            <button class="btn secondary-btn" expand="full" (click)="cancel()">Cancel</button>
          </mat-col>
        </huge-row>
      </div>
    </div>
  </mat-grid-list>
</div>
